module.exports = __webpack_public_path__ + "static/img/page_PLAY01.933c14a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/course/page_PLAY01.png
// module id = rDMG
// module chunks = 0